import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQ } from "@/content/media";
import { useLang } from "@/lang";

const EASE = [0.22, 1, 0.36, 1];

export default function Faq() {
  const { isEs } = useLang();
  const lang = isEs ? "es" : "en";
  const meta = FAQ[lang];
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.8, ease: EASE }} className="mb-6 flex items-center gap-4">
          <span className="h-px w-12 bg-gold" />
          <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold">{meta.eyebrow}</p>
        </motion.div>
        <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.8, ease: EASE, delay: 0.1 }} className="font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl">
          {meta.title}
        </motion.h2>

        <div className="mt-12 border-t border-hairline">
          {meta.items.map((item, i) => (
            <div key={item.q} className="border-b border-hairline" data-testid={`faq-item-${i + 1}`}>
              <button
                type="button"
                data-testid={`faq-question-${i + 1}`}
                aria-expanded={open === i}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-6 py-6 text-left"
              >
                <span className="font-serif text-xl font-medium leading-snug text-navy sm:text-2xl">{item.q}</span>
                <motion.span
                  animate={{ rotate: open === i ? 45 : 0 }}
                  transition={{ duration: 0.3, ease: EASE }}
                  className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold"
                >
                  <Plus className="h-4 w-4" />
                </motion.span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    key="answer"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: EASE }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 pr-10 text-base leading-relaxed text-mutedink sm:pr-16">{item.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
